<template>
  <div>
    <el-dialog title="购买sku人群" :visible.sync="dialogVisible" width="700px" :before-close="handleClose"
      :close-on-click-modal="false">
      <el-form class="new-input-box" :model="form" label-width="120px" ref="buySkuForm" v-loading="formLoading">
        <el-form-item label="人群名称" prop="name" required>
          <el-input v-model="form.name" style="width: 400px;" maxlength="50" placeholder="请输入人群名称">
            <template slot="suffix">{{ form.name.length }}/50</template>
          </el-input>
        </el-form-item>
        <el-form-item label="人群描述" prop="description" required>
          <el-input maxlength="50" style="width: 400px;" v-model="form.description" placeholder="请输入人群描述" :rows="3">
            <template slot="suffix">{{ form.description.length }}/50</template>
          </el-input>
        </el-form-item>
        <el-form-item label="目标人群在" required="">
          <el-select v-model="form.timeType" placeholder="请选择时间类型" style="width: 150px">
            <el-option label="绝对时间" value="absolute"></el-option>
            <el-option label="相对时间" value="relative"></el-option>
          </el-select>

          <template v-if="form.timeType === 'absolute'">
            <div class="my_select_time m-l-10">
              <el-date-picker prefix-icon="no_icon" v-model="form.absoluteTimeStart" type="date" placeholder="开始日期"
                size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 145px;font-size:12px;" class="time1" :clearable="false"
                :picker-options="startTimeOptions"></el-date-picker>
              <div class="time_to_text">至</div>
              <el-date-picker prefix-icon="no_icon" v-model="form.absoluteTimeEnd" type="date" placeholder="结束日期"
                size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                style="width: 150px;font-size:12px" class="time2" :clearable="false" @change="handleEndTimeChange"
                :picker-options="endTimeOptions"></el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="clearTime"></i>
              <img src="@/assets/images/select_date.svg" alt class="date_icon2" />
            </div>
          </template>

          <template v-else>
            <el-input v-model="form.relativeTimeStart" placeholder="开始天数" style="width: 150px; margin-left: 10px"
              @input="dayInput('1')"></el-input>
            <span style="margin: 0 10px">-</span>
            <el-input v-model="form.relativeTimeEnd" placeholder="结束天数" style="width: 150px"
              @input="dayInput('2')"></el-input>
            <span style="margin-left: 10px">天内</span>
          </template>
        </el-form-item>
        <div style="margin-left: 50px;">
          <span>购买过指定sku的人群</span>
          <el-button class="m-l-r-10 w-120" @click="exposureProductsFiter">
            {{
              "选择商品" + itemListForFilter.length + "/100"
            }}
          </el-button>
          <span>的人群</span>
        </div>
        <div class="custom-tip" style="margin-top: 16px;">
          <p>1.支持查询两年内的已完成订单人数;</p>
          <p>2.开始时间到结束时间的间隔最长不能超过一年;</p>
          <p>3.sku最多选择100个</p>
        </div>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleClose">取消</el-button>
        <el-button type="primary" @click="submitForm">确认</el-button>
      </div>
    </el-dialog>
    <!-- 指定购买商品 -->
    <selectGoodsMonitor ref="selectGoFilter" :isShow="selectGoodsStateFilter" @close="selectGoodsCloseFilter"
      :selectGoods="selectGoodsFilterArr" :moduleType="true" :skuSearch="true" :xianz="false">
    </selectGoodsMonitor>
  </div>
</template>

<script>
import selectGoodsMonitor from "@/components/selectGoodsMonitor2";
import { createBuySkuBehavior } from "@/api/manage/memberCrowdController";
export default {
  name: 'BuySkuCrowd',
  props: {
    visible: {
      type: Boolean,
      default: false
    }
  },
  components: {
    selectGoodsMonitor
  },
  data() {
    return {
      dialogVisible: false,
      form: {
        name: '',
        description: '',
        timeType: 'absolute',
        absoluteTimeStart: '',
        absoluteTimeEnd: '',
        relativeTimeStart: '',
        relativeTimeEnd: '',
      },
      itemListForFilter: [],
      mainImagelistFilter: [],
      selectGoodsStateFilter: false,
      selectGoodsFilterArr: [],
      formLoading: false,

      // 时间选择器配置
      startTimeOptions: {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 设置为今天的开始时刻

          // 不能选择今天及之后的日期
          if (time.getTime() >= today.getTime()) {
            return true;
          }

          // 不能选择两年前的日期
          const twoYearsBefore = new Date();
          twoYearsBefore.setFullYear(twoYearsBefore.getFullYear() - 2);
          if (time.getTime() < twoYearsBefore.getTime()) {
            return true;
          }

          return false;
        },
        // 设置默认时间为00:00:00
        selectableRange: '00:00:00 - 23:59:59'
      },
      endTimeOptions: {
        disabledDate: (time) => {
          const today = new Date();
          today.setHours(0, 0, 0, 0); // 设置为今天的开始时刻

          // 不能选择今天及之后的日期
          if (time.getTime() >= today.getTime()) {
            return true;
          }

          if (!this.form.absoluteTimeStart) {
            // 如果没有选择开始时间，则不能选择两年前的日期
            const twoYearsBefore = new Date();
            twoYearsBefore.setFullYear(twoYearsBefore.getFullYear() - 2);
            return time.getTime() < twoYearsBefore.getTime();
          }

          const startTime = new Date(this.form.absoluteTimeStart);

          // 不能选择开始时间之前的日期
          if (time.getTime() < startTime.getTime()) {
            return true;
          }

          // 不能选择开始时间365天之后的日期
          const oneYearLater = new Date(startTime);
          oneYearLater.setDate(oneYearLater.getDate() + 365);
          if (time.getTime() > oneYearLater.getTime()) {
            return true;
          }

          return false;
        },
        // 设置默认时间为23:59:59
        selectableRange: '00:00:00 - 23:59:59'
      }
    }
  },
  watch: {
    visible(val) {
      this.dialogVisible = val
    },
    dialogVisible(val) {
      if (!val) {
        this.$emit('update:visible', false)
      }
    }
  },
  methods: {
    handleClose() {
      this.$refs.buySkuForm && this.$refs.buySkuForm.resetFields()
      this.form = {
        name: '',
        description: '',
        timeType: 'absolute',
        absoluteTimeStart: '',
        absoluteTimeEnd: '',
        relativeTimeStart: '',
        relativeTimeEnd: '',
      }
      this.itemListForFilter = [];
      this.mainImagelistFilter = [];
      this.selectGoodsFilterArr = [];
      this.$emit('update:visible', false)
    },
    selectSku() {
      // 这里可以实现选择SKU的逻辑，例如打开另一个弹窗
      this.$message.info('选择SKU功能待实现')
    },
    handleEndTimeChange(val) {
      if (val) {
        // 将结束时间设置为当天的23:59:59
        const date = new Date(val);
        date.setHours(23, 59, 59);
        this.form.absoluteTimeEnd = date.getFullYear() + '-' +
          String(date.getMonth() + 1).padStart(2, '0') + '-' +
          String(date.getDate()).padStart(2, '0') + ' ' +
          '23:59:59';
      }
    },
    clearTime() {
      this.form.absoluteTimeStart = '';
      this.form.absoluteTimeEnd = '';
    },
    //指定商品弹窗
    exposureProductsFiter() {
      this.selectGoodsStateFilter = true;
      if (this.itemListForFilter.length == 0) {
        this.itemListForFilter = [];
        this.selectGoodsFilterArr = [];
        this.mainImagelistFilter = [];
      }
      this.$refs.selectGoFilter.handleRightCurrentChange(1);
    },
    //选择指定商品回调
    selectGoodsCloseFilter(data) {
      if (data) {
        if (this.itemListForFilter.length + data.length > 100) {
          this.$message.warning('总商品最多只能选100个');
          return;
        }
        this.itemListForFilter = [];
        this.mainImagelistFilter = [];
        // 总sku最多只能选100个
        data.forEach((value, index) => {
          let fomeVaule = {};
          fomeVaule.skuId = data[index].skuId;
          fomeVaule.logo = data[index].logo;
          fomeVaule.price = data[index].jdPrice || data[index].price;
          fomeVaule.title = data[index].wareTitle || data[index].title;
          this.itemListForFilter.push(fomeVaule);
          this.mainImagelistFilter.push(fomeVaule);
        });
        this.selectGoodsFilterArr = this.itemListForFilter;
      }
      this.selectGoodsStateFilter = false;
    },
    // 相对时间输入框限制
    dayInput(type) {
      // 只允许输入数字
      if (type === '1') { // 开始时间
        this.form.relativeTimeStart = this.form.relativeTimeStart.replace(/[^\d]/g, '');
        // 确保不超过最大值
        if (parseInt(this.form.relativeTimeStart) > 730) { // 2年 = 730天
          this.form.relativeTimeStart = '730';
          this.$message.warning('开始天数不能超过730天(2年)');
        }
      } else { // 结束时间
        this.form.relativeTimeEnd = this.form.relativeTimeEnd.replace(/[^\d]/g, '');
        // 确保不超过最大值
        if (parseInt(this.form.relativeTimeEnd) > 730) { // 2年 = 730天
          this.form.relativeTimeEnd = '730';
          this.$message.warning('结束天数不能超过730天(2年)');
        }
        // 确保结束时间大于开始时间
        if (this.form.relativeTimeStart && this.form.relativeTimeEnd) {
          const start = parseInt(this.form.relativeTimeStart);
          const end = parseInt(this.form.relativeTimeEnd);
          // 确保时间间隔不超过365天
          if (end - start > 365) {
            this.form.relativeTimeEnd = String(start + 365);
            this.$message.warning('时间间隔最多为365天');
          }
        }
      }
    },
    submitForm() {
      // 名称必填
      if (!this.form.name) {
        this.$message.warning('请输入人群名称');
        return;
      }
      // 描述必填
      if (!this.form.description) {
        this.$message.warning('请输入人群描述');
        return;
      }
      // 相对时间的时候开始时间和结束时间必填
      if (this.form.timeType === 'relative' && (!this.form.relativeTimeStart || !this.form.relativeTimeEnd)) {
        this.$message.warning('请输入开始天数和结束天数');
        return;
      }
      // 绝对时间的开始时间和结束时间必填
      if (this.form.timeType === 'absolute' && (!this.form.absoluteTimeStart || !this.form.absoluteTimeEnd)) {
        this.$message.warning('请选择开始日期和结束日期');
        return;
      }
      // 相对时间的结束时间需要大于开始时间
      if (this.form.timeType === 'relative' && this.form.relativeTimeStart && this.form.relativeTimeEnd) {
        if (parseInt(this.form.relativeTimeEnd) <= parseInt(this.form.relativeTimeStart)) {
          this.$message.warning('结束天数必须大于开始天数');
          return;
        }
      }
      // 商品列表不能为空
      if (this.itemListForFilter.length === 0) {
        this.$message.warning('请选择商品');
        return;
      }

      // 构建提交数据
      const submitData = {
        crowdName: this.form.name,
        description: this.form.description,
        searchType: this.form.timeType === 'absolute'
          ? 0
          : 1,
        skuIds: this.itemListForFilter.map(item => item.skuId).join(','),
      }
      if (this.form.timeType === 'absolute') { // 绝对时间
        submitData.startTime = this.form.absoluteTimeStart
        submitData.endTime = this.form.absoluteTimeEnd
      } else { // 相对时间
        submitData.startDay = this.form.relativeTimeStart
        submitData.endDay = this.form.relativeTimeEnd
      }

      console.log("--- submitData:---", submitData)
      this.formLoading = true
      // 调用接口创建人群
      createBuySkuBehavior(submitData).then(res => {
        this.formLoading = false
        if (res.code === 200 || res.code === 1) {
          this.$emit('createSuccess')
        } else {
          this.$message.error(res.message)
        }
      }).catch(err => {
        this.formLoading = false
        this.$message.error(err.message)
      })
    }
  }
}
</script>

<style scoped>
.tips {
  background-color: #f8f8f8;
  padding: 10px;
  margin-top: 20px;
  color: #666;
  font-size: 12px;
  border-radius: 4px;
}

.tips p {
  margin: 5px 0;
}

:deep(.el-form-item__error) {
  display: none;
}

.m-l-10 {
  margin-left: 10px;
}

.m-l-r-10 {
  margin: 0 10px;
}

.w-120 {
  width: 120px;
}

.custom-tip {
  background-color: #F4F4F5;
  padding: 9px 14px;
  color: #666;
  font-size: 12px;
  line-height: 22px;
  border-radius: 4px;
}

.custom-tip p {
  margin: 0;
}
</style>